import { useAgentEventsStream } from 'features/trend-detection/hooks/use-agent-events-stream'
import { useAgentRunToasts } from 'features/trend-detection/hooks/use-agent-run-toasts'

/**
 * The single app-wide agent-events mount, composed for `ProjectLayout`: it opens
 * the one SSE connection (`useAgentEventsStream`) and wires the completion/
 * failure toasts (`useAgentRunToasts`) that read off it. Mounting one hook keeps
 * the connection and the toasts strictly co-mounted — the toasts subscribe to
 * the stream's module-level fan-out, so they are inert without the connection.
 *
 * Pass `undefined` (e.g. for a locked project) to open no stream and fire no
 * toasts.
 */
export function useAppAgentEvents(projectId: string | null | undefined): void {
  useAgentEventsStream(projectId)
  useAgentRunToasts(projectId)
}
